import type { InteractionType } from '@cult/domain';
import type { UserSummary } from '@cult/schemas';
import { Flex, Typography } from 'antd';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import { SenderRecipient } from '../../../../components';
import { InteractionTypeBadge } from '../InteractionTypeBadge/InteractionTypeBadge';

dayjs.extend(relativeTime);

type Props = {
  type: InteractionType;
  author: UserSummary;
  receiver: UserSummary;
  createdAt: string | Date;
};

export const InteractionDetailHeader = ({ type, author, receiver, createdAt }: Props) => (
  <Flex vertical gap={12}>
    <InteractionTypeBadge type={type} />
    <SenderRecipient author={author} receiver={receiver}>
      <Typography.Text type="secondary" style={{ fontSize: 12 }}>
        · {dayjs(createdAt).fromNow()}
      </Typography.Text>
    </SenderRecipient>
  </Flex>
);
